import { NotificationsTopics } from "../types";

const supportedAnalyticsSources: NotificationsTopics[] = [
  "tenSessionsTutoringParentInvite",
  "childCompletesAssignment",
  "childAssignmentSet",
  "parentWeeklyReport"
];

export default function isSupportedAnalyticsSource(
  source: NotificationsTopics | null
) {
  if (!source) return false;

  return supportedAnalyticsSources.some(supported => supported === source);
}
